const configGradeData = [
    {
        value: 1,
        label: '一年级',
    },
    {
        value: 2,
        label: '二年级',
    },
    {
        value: 3,
        label: '三年级',
    },
    {
        value: 4,
        label: '四年级',
    },
    {
        value: 5,
        label: '五年级',
    }, 
    {
        value: 6,
        label: '六年级/预初',
    }, 
    {
        value: 7,
        label: '初一',
    }, 
    {
        value: 8,
        label: '初二',
    }, 
    {
        value: 9,
        label: '初三',
    }, 
    {
        value: 10,
        label: '高一',
    }, 
    {
        value: 11,
        label: '高二',
    }, 
    {
        value: 12,
        label: '高三',
    }, 
]

const configClassData = [
    {
        value: 1,
        label: '1班',
    },
    {
        value: 2,
        label: '2班',
    },
    {
        value: 3,
        label: '3班',
    },
    {
        value: 4,
        label: '4班',
    },
    {
        value: 5,
        label: '5班',
    }, 
    {
        value: 6,
        label: '6班',
    }, 
    {
        value: 7,
        label: '7班',
    }, 
    {
        value: 8,
        label: '8班',
    }, 
    {
        value: 9,
        label: '9班',
    }, 
    {
        value: 10,
        label: '10班',
    }, 
    {
        value: 11,
        label: '11班',
    }, 
    {
        value: 12,
        label: '12班',
    },
    {
        value: 13,
        label: '13班',
    },
    {
        value: 14,
        label: '14班',
    },
    {
        value: 15,
        label: '15班',
    },
    {
        value: 16,
        label: '16班',
    },
    {
        value: 17,
        label: '17班',
    },
    {
        value: 18,
        label: '18班',
    },
    {
        value: 19,
        label: '19班',
    },
    {
        value: 20,
        label: '20班',
    },
]

const configSemesterData = [
    {
        value: 1,
        label: '上学期',
    },
    {
        value: 2,
        label: '下学期',
    },
]

const configExamNameData = [
    {
        value: '单元一',
        label: '单元一',
    },
    {
        value: '单元二',
        label: '单元二',
    },
    {
        value: '第一次月考',
        label: '第一次月考',
    },
    {
        value: '单元三',
        label: '单元三',
    },
    {
        value: '单元四',
        label: '单元四',
    },
    {
        value: '期中',
        label: '期中',
    },
    {
        value: '单元五',
        label: '单元五',
    },
    {
        value: '单元六',
        label: '单元六',
    },
    {
        value: '第二次月考',
        label: '第二次月考',
    },
    {
        value: '单元七',
        label: '单元七',
    },
    {
        value: '单元八',
        label: '单元八',
    },
    {
        value: '期末',
        label: '期末',
    },
]

const confgitYearData = ()=> {
    const currentYear = new Date().getFullYear();
    let data = []
    for(let i=currentYear; i>currentYear - 10; i--) {
        data.push({value:i,label:i+'年'})
    }
    return data
}

const confgitYearDataReturn = confgitYearData();


const configSubjectData = [
    {
        value: '语文',
        label: '语文',
    },
    {
        value: '数学',
        label: '数学',
    },
    {
        value: '英语',
        label: '英语',
    },
    {
        value: '物理',
        label: '物理',
    },
    {
        value: '化学',
        label: '化学',
    },
    {
        value: '生物',
        label: '生物',
    },
    {
        value: '政治',
        label: '政治',
    },
    {
        value: '历史',
        label: '历史',
    },
    {
        value: '地理',
        label: '地理',
    },
    {
        value: '道法',
        label: '道法',
    },
]

const configNewsTypeData = [
    {
        value: '教育动态',
        label: '教育动态',
      },
      {
        value: '育娃宝典',
        label: '育娃宝典',
      },
      {
        value: '信息推荐',
        label: '信息推荐',
      },
      {
        value: '关于我们',
        label: '关于我们',
      },
]

const configAdviceTypeData = [
    {
        value: '程序缺陷',
        label: '程序缺陷',
      },
      {
        value: '新想法',
        label: '新想法',
      },
]

const configDocmentTypeData = [
    {
        value: '文档资料',
        label: '文档资料',
      },
      {
        value: '生活随笔',
        label: '生活随笔',
      },
]

const configBannerTypeData = [
    {
        value: 1,
        label: '活动横幅',
      },
      {
        value: 2,
        label: '俱乐部横幅',
      },
]

export default {
    configGradeData,
    configClassData,
    configSemesterData,
    configExamNameData,
    confgitYearDataReturn,
    configSubjectData,
    configNewsTypeData,
    configAdviceTypeData,
    configDocmentTypeData,
    configBannerTypeData,
}